import React from 'react';

const PurchaseButton = ({ action }) => {
    return <button className="purchase-button btn" onClick={action}>
        Purchase
    </button>
};

export default PurchaseButton;